import { useWebSocketApi } from '@e3dc-react/shell/Hooks'
import { SocketStateModel } from '@e3dc-react/shell/Hooks/use-websocket-api'
import { isUndefined } from 'lodash'
import { WallboxStatusModel } from '../models'
import { WallboxStatusDto } from '../api'
import { fromStatusDtoToModel } from '../transformers'

const SERVICE_ID = '[WALLBOX LIVE STATUS]'

/**
 * This hook provides wallboxes status through a websocket connection
 */
const useLiveWallboxStatus = (storageId: string | undefined): SocketStateModel<WallboxStatusModel[]> => {
  const resourcePath = `wallboxes/${storageId}/status/ws`

  const { socketState } = useWebSocketApi<WallboxStatusModel[], WallboxStatusDto[]>({
    apiResourcePath: resourcePath,
    loggerKey: SERVICE_ID,
    transformer: fromStatusDtoToModel,
    doNotInitialize: isUndefined(storageId),
    dependencies: [storageId],
    endpoint: process.env.REACT_APP_API_ENDPOINT ?? '',
  })

  return socketState
}

export default useLiveWallboxStatus
